const productFragment = `
  id
  slug
  name
  category {
    name
  }
  productType {
    name
  }
  thumbnail(size: 340) {
    url
    alt
  }
`;

const productsQueryWithChannel = `
  query getProducts($search: String) {
    products(first: 24, filter: { search: $search }, channel: "default-channel") {
      edges {
        node {
          ${productFragment}
        }
      }
    }
  }
`;

const productsQuery = `
  query getProducts($search: String) {
    products(first: 24, filter: { search: $search }) {
      edges {
        node {
          ${productFragment}
        }
      }
    }
  }
`;

const productQueryWithChannel = `
  query getProduct($slug: String!) {
    product(slug: $slug, channel: "default-channel") {
      ${productFragment}
    }
  }
`;

const productQuery = `
  query getProduct($slug: String!) {
    product(slug: $slug) {
      ${productFragment}
    }
  }
`;

const normalizeProduct = product => (
  Object.assign(
    product,
    {
      imageUrl: product.thumbnail?.url,
    },
  )
);

const normalizeProducts = products => (
  products.edges.map(({ node }) => normalizeProduct(node))
);

export default class SaleorClient {
  constructor({ saleorApiUrl, channel }) {
    this.saleorApiUrl = saleorApiUrl;
    this.channel = channel;
  }

  productsMatching(search) {
    return this.fetch({
      query: this.channel ? productsQueryWithChannel : productsQuery,
      variables: { search: search || null },
    }).then(result => normalizeProducts(result.products));
  }

  productBySlug(slug) {
    return this.fetch({
      query: this.channel ? productQueryWithChannel : productQuery,
      variables: { slug },
    }).then(result => normalizeProduct(result.product));
  }

  fetch(body) {
    return fetch(
      `${this.saleorApiUrl}/graphql/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      },
    )
      .then(res => res.json())
      .then(res => res.data);
  }
}
